export const theme = {
  light: {
    'body-bg': '#f8fafc',
    'text-primary': '#1e293b',
    'sidebar-bg': '#ffffff',
    'sidebar-color': '#1e293b',
    'sidebar-border': '#e2e8f0',
    'sidebar-hover': 'rgba(15, 98, 249, 0.08)',
    'sidebar-active': 'rgba(15, 98, 249, 0.16)',
    'sidebar-shadow': '0 2px 4px rgba(0,0,0,0.1)',
    'primary': '#0F62F9',
    'primary-light': '#4A90E2',
    'primary-dark': '#0D47A1',
    'primary-gradient': 'linear-gradient(135deg, #0F62F9 0%, #4A90E2 100%)'
  },
  dark: {
    'body-bg': '#0f172a',
    'text-primary': '#f1f5f9',
    'sidebar-bg': '#1e293b',
    'sidebar-color': '#f1f5f9',
    'sidebar-border': '#334155',
    'sidebar-hover': 'rgba(74, 144, 226, 0.08)',
    'sidebar-active': 'rgba(74, 144, 226, 0.16)',
    'sidebar-shadow': '0 2px 4px rgba(0,0,0,0.2)',
    'primary': '#4A90E2',
    'primary-light': '#0F62F9'
  }
}; 